import { http } from '../utils/http';

export function getMaintRecords(deviceId, signal) {
    return http.get(`/maintenance/${deviceId}/get_records`, { signal });
}

// Accept payload as-is (snake_case expected by backend)
export function createMaintRecord(deviceId, payload, signal) {
    return http.post(`/maintenance/${deviceId}/create_record`, payload, { signal });
}

// Accept payload as-is (snake_case expected by backend)
export function updateMaintRecord(deviceId, recordId, payload) {
    return http.put(`/maintenance/${deviceId}/update_record/${recordId}`, payload);
}

export function deleteMaintRecord(deviceId, recordId) {
    return http.delete(`/maintenance/${deviceId}/delete_record/${recordId}`);
}
